import React from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '../../Button/PlainButtonOrLink';
import s from './EmailVerificationReminder.scss';
export var EmailVerificationReminder = function (_a) {
    var pushVerificationPopup = _a.pushVerificationPopup;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("span", null,
            t('siteHeader.verification.bannerText'),
            ' ',
            React.createElement(PlainButtonOrLink, { className: s['resend-link'], onClick: function (e) {
                    e.preventDefault();
                    pushVerificationPopup();
                } }, t('siteHeader.verification.didntGetEmail')))));
};
EmailVerificationReminder.displayName = 'EmailVerificationReminder';
export default EmailVerificationReminder;
//# sourceMappingURL=EmailVerificationReminder.js.map